import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Program History|Continuing Education|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialContinuingEducation,
	portal: 'SP',
};
const columnHeadingDescriptionStart = 'Column heading for: ';

export type SPCandidateCEPastLocNames =
	| `SPCandidateCEPastTitleSection`
	| `SPCandidateCEPastLabelName`
	| `SPCandidateCEPastLabelActiveDate`
	| `SPCandidateCEPastLabelExpireDate`
	| `SPCandidateCEPastLabelUpdated`
	| `SPCandidateCEPastLabelReviewStatus`
	| `SPCandidateCEPastLabelInvalid`
	| `SPCandidateCEPastLabelDataProvider`
	| `SPCandidateCEPastLabelCourseName`
	| `SPCandidateCEPastLabelDocumentation`
	| `SPCandidateCEPastLabelPoints`;

export const spCandidateCEPastLocs: LocDefs<SPCandidateCEPastLocNames> = {
	SPCandidateCEPastTitleSection: {
		defaultValue: 'Past',
		description: `Continuing education past section title.`,
		displayPath: `${pathStart}Past Section Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPCandidateCEPastLabelName: {
		defaultValue: 'Name',
		description: `${columnHeadingDescriptionStart}Name.`,
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateCEPastLabelActiveDate: {
		defaultValue: 'Active Date',
		description: `${columnHeadingDescriptionStart}Active Date.`,
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCandidateCEPastLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: `${columnHeadingDescriptionStart}Expire Date.`,
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
	SPCandidateCEPastLabelUpdated: {
		defaultValue: 'Updated',
		description: `${columnHeadingDescriptionStart}Updated.`,
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.Updated',
		...sharedProperties,
	},
	SPCandidateCEPastLabelReviewStatus: {
		defaultValue: 'Review Status',
		description: `${columnHeadingDescriptionStart}Review Status.`,
		displayPath: `${pathStart}Review Status`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.ReviewStatus',
		...sharedProperties,
	},
	SPCandidateCEPastLabelInvalid: {
		defaultValue: 'Invalid',
		description: `${columnHeadingDescriptionStart}Invalid.`,
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.Invalid',
		...sharedProperties,
	},
	SPCandidateCEPastLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: `${columnHeadingDescriptionStart}Data Provider.`,
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.DataProvider',
		...sharedProperties,
	},
	SPCandidateCEPastLabelCourseName: {
		defaultValue: 'Course Name',
		description: `${columnHeadingDescriptionStart}Course Name.`,
		displayPath: `${pathStart}Course Name`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation.CECourseName/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.CourseName',
		...sharedProperties,
		feature: HubFeature.CredentialContinuingEducationCeCourseName,
	},
	SPCandidateCEPastLabelDocumentation: {
		defaultValue: 'Documentation',
		description: `${columnHeadingDescriptionStart}Documentation.`,
		displayPath: `${pathStart}Documentation`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.Documentation',
		...sharedProperties,
	},
	SPCandidateCEPastLabelPoints: {
		defaultValue: 'Points',
		description: `${columnHeadingDescriptionStart}Points.`,
		displayPath: `${pathStart}Points`,
		displayType: 'Label',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.ColumnHeading.PointsValue',
		...sharedProperties,
	},
};

export type SPCandidateCEPastLocType = LocMap<SPCandidateCEPastLocNames>;
